import IBlock2Income from "./IBlock2Income";
import { EnumUtil } from "@/app";

export default class BLock2Income implements IBlock2Income {
    constructor(
        public type: string = EnumUtil.EMPTY_OPTION,
        public income: string = "",
        public employedFrom: Date | undefined = undefined,
        public householdIncome: string = "",
        public expenses: string = ""
    ) {}
}
